<template>
  <div>
    <slot name="pager"></slot>
    <div
      id="fullscreen-wrapper"
      :class="getClasses['wrapper']"
      @click="onClickOutsideModelContent"
    />
    <div
      id="fullscreen-mod"
      :class="getClasses['modal']"
      @click="onClickOutsideModelContent"
      style="display: block"
    >
      <div :class="getClasses['tableWrapper']">
        <div class="full-screen-div">
          <header
            v-if="open"
            id="close-pickup-modal___BV_modal_header_"
            class="modal-header full-screen-header"
          >
            <h5 id="close-fullscreen-header_text" class="modal-title">
              {{ headerText }}
            </h5>
            <button
              type="button"
              @click="openContent(!open)"
              aria-label="Close"
              style="margin: 0"
              class="close"
            >
              ×
            </button>
          </header>
        </div>
        <div :class="getClasses['contentPad']">
          <div class="top-grid">
            <div class="flex-left">
              <slot name="topleft"> </slot>
            </div>
            <div class="flex-right">
              <slot name="topright"> </slot>
              <VActionButton
                :label="open ? 'Close' : 'Expand'"
                :show-icon="false"
                :show-badge="false"
                @click="openContent(!open)"
              />
            </div>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PathMapper from "../lib/PathMapper";
import VActionButton from "./raft/VActionButton.vue";

export default {
  name: "RAFTFullScreenContent",
  data() {
    return {
      open: false,
      openClasses: {
        wrapper: "modal-backdrop full-screen-mod-wrap",
        modal: "modal fade show full-screen-mod",
        tableWrapper: "modal-dialog-scrollable modal-content full-size",
        contentPad: "full-screen-model-pad",
      },
    };
  },
  watch: {
    fullScreen(newVal) {
      this.openContent(newVal);
    },
  },
  mounted() {
    const self = this;
    if (this.escapeToClose) {
      window.addEventListener("keyup", (event) => {
        // If  ESC key was pressed...
        if (event.key === "Escape") {
          self.openContent(false);
        }
      });
    }
  },
  methods: {
    onClickOutsideModelContent(event) {
      if (
        event.target.id === "fullscreen-mod" ||
        event.target.id === "fullscreen-wrapper"
      ) {
        this.openContent(!this.open);
      }
    },
    openContent(newVal) {
      this.open = newVal;
      this.$emit("openClose", newVal);
    },
  },
  computed: {
    getClasses() {
      if (this.open) {
        return this.openClasses;
      }
      return {
        wrapper: "",
        modal: "",
        tableWrapper: "",
        contentPad: "",
      };
    },
    getOpenIconPath: function () {
      return PathMapper.getIconAssetPath("expandScreen.png", false);
    },
  },
  props: {
    fullScreen: { type: Boolean, default: false },
    escapeToClose: { type: Boolean, default: true },
    headerText: { type: String, default: "" },
  },
  components: {
    VActionButton,
  },
};
</script>

<style scoped>
/* The b-modal component uses a z-index of 1040, so go a little below that. */
.full-screen-mod-wrap {
  z-index: 500;
}
.full-size {
  z-index: 510;
  overflow: scroll;
  height: 92%;
  width: 96vw;
  margin: 4vh 2vw 4vh;
}
.full-screen-mod {
  z-index: 510;
  padding-bottom: 0;
  overflow: scroll;
}
.full-screen-div {
  display: block;
}
.full-screen-icon {
  right: 20px;
  height: 16px;
  position: absolute;
}
.full-screen-header {
  max-height: 20px;
}
.full-screen-model-pad {
  overflow: scroll;
  margin: 10px;
}

.top-grid {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: max-content 1fr;
}

@media only screen and (max-width: 37.5rem) {
  .top-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
}

.flex-row {
  display: flex;
  column-gap: 0.25rem;
}
.flex-right {
  margin-left: auto;
  display: flex;
  column-gap: 0.25rem;
}
:is(#raft-js, #raft-js-app) div >>> .view-pager-total {
  text-align: left;
  margin: 0.25rem 0;
}

.bio-space-listing #fullscreen-mod .top-grid {
  margin: 0.25rem 0.2rem;
}
</style>
